import { useEffect } from 'react';
import { usePusher } from '../../../../../../../hooks/usePusher';
import { Meetingroom } from '../../../../../../../interfaces/interfaces';
import { setMeeting } from '../../../../../../../reduxToolkit/slices/videoSlice';
import { useSelector, useDispatch } from '../../../../../../../reduxToolkit/typedRedux';
import { useChat } from '../../../../../../meeting/hooks/useChat';
import { setPlayChatSound } from '../../../../../../../reduxToolkit/slices/chatSlice';
import { MeetingChat } from '../../../../../chat/MeetingChat';
import { store } from '../../../../../../../reduxToolkit/store';

export const PresentationLivestreamChat = ({ meeting }: { meeting?: Meetingroom }) => {
  const meetingChannel = useSelector(({ common }) => common.pusherChannels.meetingChannel);
  const dispatch = useDispatch();
  const chat = useChat(meeting?._id);
  const pusher = usePusher();
  const roomMeeting = useSelector(({ video }) => video.meeting);

  useEffect(() => {
    if (meeting) {
      dispatch(setMeeting(meeting));
    }
  }, [meeting]);

  useEffect(() => {
    if (meeting && roomMeeting) {
      chat.init();
      pusher.setupMeetingChannel(meeting._id);
    }
  }, [meeting, roomMeeting]);

  useEffect(() => {
    if (meetingChannel && roomMeeting && roomMeeting._id) {
      chat.setupChatChannel();
    }
  }, [meetingChannel, roomMeeting]);

  useEffect(() => {
    dispatch(setPlayChatSound(false));

    return () => {
      store.getState().common.pusherChannels.meetingChannel?.unsubscribe();
    };
  }, []);

  if (!meeting || !meetingChannel || !roomMeeting) return null;
  return <MeetingChat meetingId={meeting._id} />;
};
